import { Box, Button, Divider, Flex, FormControl, HStack, Radio, RadioGroup, Stack, Text } from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import routes from '../../../pages/routes';
import SurveyService from '../../../services/admin/survey.service';
import Loading from '../../common/Loading';

const Others = ({ prePage, othersQuestions, othersTemplateCode, userId, emailAdress, trainerId, centerId, ...rest }: {prePage: any, othersQuestions: Array<object> , othersTemplateCode: string, userId:number, emailAdress:string, trainerId:string, centerId:string}) => {

    const mountedRef = useRef(true)

    const courseFormatRef = useRef<HTMLSelectElement>(null)
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const params:any = useParams();
    const [uniqueObjects, setUniqueObjects] = useState<UniqueObjects>({});
    
    type AnswerObject = {
        uuid: string;
        answer: string;
    };

    type UniqueObjects = {
        [uuid: string]: AnswerObject;
    };
    // const toast = useToast();

    const createUniqueObj = async (e: React.ChangeEvent<HTMLInputElement>, question_uuid: string) => {
        const questionUUID = question_uuid;
        const newAnswerObject: AnswerObject = {
            uuid: questionUUID,
            answer: e.target.value,
        };

        setUniqueObjects((prevState) => {
            const newState = { ...prevState };
            const objectExists = Object.keys(newState).some((key) => key === questionUUID);
            if (objectExists) {
                newState[questionUUID as keyof typeof newState] = newAnswerObject;
            } else {
                newState[questionUUID as keyof typeof newState] = newAnswerObject;
            }
            return newState;
        });

        
    };

    const handleCreateSurvey = async () => {
        const promises = Object.values(uniqueObjects).map((uniqueObject) => {
            const surveyAnswerSet = {
            survey_id: params.survey_uuid,
            template_code: othersTemplateCode,
            answer: uniqueObject.answer,
            answered_by: "user",
            answered_by_id: userId.toString(),
            answered_by_email: emailAdress,
            trainer_id: trainerId,
            centre_id: centerId
            };
            return SurveyService.createSurveyAnswer(uniqueObject.uuid, surveyAnswerSet);
        });
        
        try {
            const responses = await Promise.all(promises);
            
            
            navigate(routes.SurveyEntryLink(params.course_id))
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (othersQuestions.length > 0) {
            setLoading(false)
        }
    }, []);


   
    return (
        <>
            <Text fontWeight={600}>OTHERS</Text>
                <Stack mt="18px" ml="20px" width="960px" height="auto" spacing="26px" pt="18px" px="40px">
                    {
                        loading ? <Box width="90%" mx="auto"><Loading/></Box> :
                        othersQuestions.length > 0 ?
                            othersQuestions.map((question: any, index: number) => (
                                <Box key={question.uuid}>
                                    <Text>{index + 1}. {question.question}</Text>
                                    <Flex direction="row" my="26px" textAlign="center" justifyContent="space-between" alignItems="center" width="80%" height="auto">
                                        <Text>Horrible</Text>
                                        <Box>
                                            <FormControl as='fieldset' onChange={(e: React.ChangeEvent<HTMLInputElement>) => createUniqueObj(e, question.uuid)}>
                                                <RadioGroup colorScheme='red'>
                                                    <HStack spacing='42px'>
                                                        <Flex direction="column" justifyContent='space-between' alignItems='center' gap={4}>
                                                            <Text>1</Text>
                                                            <Radio value='1'></Radio>
                                                        </Flex>
                                                        <Flex direction="column" justifyContent='space-between' alignItems='center' gap={4}>
                                                            <Text>2</Text>
                                                            <Radio value='2'></Radio>
                                                        </Flex>
                                                        <Flex direction="column" justifyContent='space-between' alignItems='center' gap={4}>
                                                            <Text>3</Text>
                                                            <Radio value='3'></Radio>
                                                        </Flex>
                                                        <Flex direction="column" justifyContent='space-between' alignItems='center' gap={4}>
                                                            <Text>4</Text>
                                                            <Radio value='4'></Radio>
                                                        </Flex>
                                                        <Flex direction="column" justifyContent='space-between' alignItems='center' gap={4}>
                                                            <Text>5</Text>
                                                            <Radio value='5'></Radio>
                                                        </Flex>
                                                    </HStack>
                                                </RadioGroup>
                                            </FormControl>
                                        </Box>
                                        <Text>Best Ever</Text>
                                    </Flex>
                                    <Divider mt="2rem" width="80%" height="2px" borderColor="#9E9E9E" />
                                </Box>
                            )) : ""
                    }

                    <Flex justifyContent="space-between" alignContent="center" pt="66px" ml="0" width="80%">
                        <Button py='16px' px='30px' type="submit" fontSize={12} borderRadius={0} backgroundColor="#F5F5F5" size='sm' onClick={() => prePage()}>
                            PREVIOUS
                        </Button>
                        <Button py='16px' px='30px' type="submit" fontSize={12} borderRadius={0} colorScheme='red' size='sm' onClick={() => handleCreateSurvey() }>
                            SAVE & EXIT
                        </Button>
                    </Flex>
                </Stack>
        </>
    );
}

export default Others;